import React from 'react';
import PropTypes from 'prop-types';
import { featureKeys } from 'services/FeatureFlagService';
import NavigationProvider from 'Workspace/containers/NavigationProvider';
import Navigation from 'components/Navigation';

import navItems from './navItems.json';
import navItemsNewUX from './navItemsNewUX.json';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';

const HomeNavigation = ({ selectedKey, showHeader = true, getFeatureFlagValue }) => {
  const isRedesignedWorkspaceNew = getFeatureFlagValue(featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22);
  
  return (
    <NavigationProvider
      navItems={isRedesignedWorkspaceNew ? navItemsNewUX : navItems}
      render={
        (userNavItems) =>
          <Navigation items={userNavItems} selectedKey={selectedKey} showHeader={showHeader} />
      }
    />
  );
};

HomeNavigation.propTypes = {
  selectedKey: PropTypes.string,
};

const flagNames = [featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22];
export default enhanceWithFeatureFlagSubscription(HomeNavigation, flagNames);
